const UserCollectionFields = [
];

export default UserCollectionFields;